import { Component } from '@angular/core';
import {Router, RouterModule} from "@angular/router";
import SharedModule from "../shared/shared.module";
import {ViewportScroller} from "@angular/common";

@Component({
  selector: 'jhi-institution',
  standalone: true,
  imports: [RouterModule, SharedModule],
  templateUrl: './institution.component.html',
  styleUrl: './institution.component.scss'
})
export class InstitutionComponent {

  constructor(private scroller: ViewportScroller) {

  }

  goToSupport() {
    this.scroller.scrollToAnchor("support");
  }

  goToExpert() {
    this.scroller.scrollToAnchor("expert");
  }

  goToFach() {
    this.scroller.scrollToAnchor("fach");
  }



}
